module.exports = __webpack_public_path__ + "static/media/blockTribune.8f98ac0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/blockTribune.png
// module id = 1815
// module chunks = 146